import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Resets scroll position on navigation, which the router does not do itself. */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
